import React, { useState, useEffect } from 'react'
import { Redirect, useRouteMatch } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import Icon from 'components/Icon'

const Review = ({ setCallback, supplier: { stage, status }, match: { params: { supplierId } } }) => {
  const { url } = useRouteMatch()
  const [review, setReview] = useState(null)
  const [redirect, setRedirect] = useState(null)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://player.vimeo.com/api/player.js'
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  useEffect(() => {
    if (stage == 'NEW' && status == 'ONBOARDING') {
      fetch(`/rest/v2/supplier/${supplierId}/submit`, {
        credentials: 'same-origin',
        method: 'PUT',
      })
        .then((response) => response.json())
        .then(({ meta: { handledAsExisting } }) => {
          if (handledAsExisting) {
            setRedirect(true)
          }
        })
        .catch((error) => window.alert(error))
    }

    if (stage == 'NEW' && status == 'IN REVIEW') {
      fetch(`/rest/v2/supplier/${supplierId}/application`, { credentials: 'same-origin' })
        .then((response) => response.json())
        .then(({ review }) => setReview(review))
        .catch((error) => window.alert(error))
    }

    setCallback((event) => {
      return Promise.resolve()
    })
  }, [])

  if (redirect) {
    return (
      <Redirect to={url.replace(/[^/]*$/, 'rates')} />
    )
  }

  if (review && status == 'IN REVIEW') {
    return (
      <div>
        <div className="font-medium text-4xl">
          <FormattedMessage {...messages.titleInReview } />
        </div>

        <div className="border-l-2 border-gray-400 pl-4 text-gray-700 mt-6 whitespace-pre-line">
          <p>{ review }</p>
        </div>
      </div>
    )
  }

  if (status == 'ACCEPTED') {
    return (
      <div>
        <div className="font-medium text-4xl">
          <FormattedMessage {...messages.titleAccepted } /> <Icon icon={['fal', 'rocket']} />
        </div>

        <div className="text-gray-700 mt-6 whitespace-pre-line">
          <FormattedMessage {...messages.subtitleAccepted } />
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="font-medium text-4xl">
        <FormattedMessage {...messages.title } /> <Icon icon="coffee-togo" />
      </div>

      <div className="text-gray-700 mt-6 whitespace-pre-line">
        <FormattedMessage {...messages.subtitle } values={{
          link: (chunks) => (
            <a className="text-primary cursor-pointer" target="_blank" href="https://www.voicearchive.com/difference-between-marketplace-voicearchive/">
              { chunks }
            </a>
          )
        }} />
      </div>

      <div className="mt-12" style={{ padding: '44.27% 0 0 0', position: 'relative' }}>
        <iframe
          src="https://player.vimeo.com/video/445225033?autoplay=0&title=0&byline=0&portrait=0"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          frameBorder="0"
          allow="fullscreen"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export default Review
